import { EnvironmentConfig } from '../environment-config';

export const useFeatureFlag = (flagName: keyof typeof EnvironmentConfig['featureFlags']) => {
  return EnvironmentConfig.featureFlags[flagName] !== undefined;
};
